const CLOUDINARY_IMAGE_BASE = 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto';
const CLOUDINARY_IMAGE_ASSET_PATH = '/v1/attachments/generic_asset/asset';
const CLOUDINARY_VIDEO_OPTIMIZED_BASE = 'https://fiverr-res.cloudinary.com/video/upload/f_auto:video,q_auto:eco';
const CLOUDINARY_VIDEO_LIGHT_BASE = 'https://fiverr-res.cloudinary.com/video/upload/f_auto,q_auto:low';
const CLOUDINARY_VIDEO_POSTER_BASE =
    'https://fiverr-res.cloudinary.com/video/upload/f_jpg,q_auto,so_0/v1/video-attachments/generic_asset/asset';

export const cloudinaryImage = (assetId: string, width?: number): string =>
    `${CLOUDINARY_IMAGE_BASE}${width ? `,w_${width}` : ''}${CLOUDINARY_IMAGE_ASSET_PATH}/${assetId}`;
export const cloudinaryVideo = (assetId: string, params?: string): string =>
    `${CLOUDINARY_VIDEO_OPTIMIZED_BASE}${
        params ? `,${params}` : ''
    }/v1/video-attachments/generic_asset/asset/${assetId}`;
export const cloudinaryVideoPreview = (assetId: string, params?: string): string =>
    `${CLOUDINARY_VIDEO_LIGHT_BASE},ac_none${
        params ? `,${params}` : ''
    }/v1/video-attachments/generic_asset/asset/${assetId}`;
export const cloudinaryVideoPoster = (assetId: string, startOffset?: number): string =>
    startOffset !== undefined
        ? `https://fiverr-res.cloudinary.com/video/upload/f_jpg,q_auto,so_${startOffset}/v1/video-attachments/generic_asset/asset/${assetId}`
        : `${CLOUDINARY_VIDEO_POSTER_BASE}/${assetId}`;
export const cloudinaryStaticPoster = (assetId: string, width?: number, startOffset = 0): string =>
    `https://fiverr-res.cloudinary.com/video/upload/f_auto,q_auto,so_${startOffset}${
        width ? `,w_${width}` : ''
    }/v1/video-attachments/generic_asset/asset/${assetId}`;

export const withVideoWidth = (videoUrl: string, width: number): string =>
    videoUrl.replace(/\/w_\d+\//, `/w_${width}/`);

export const withVideoQuality = (videoUrl: string, quality: string): string =>
    videoUrl.replace(/q_auto(?::\w+)?/, quality === 'good' ? 'q_auto' : `q_auto:${quality}`);

const VIDEO_ASSET_MARKER = '/v1/video-attachments/generic_asset/asset/';
export const toVideoPreviewUrl = (videoUrl: string): string => {
    const idx = videoUrl.indexOf(VIDEO_ASSET_MARKER);
    if (idx === -1) {
        return '';
    }
    return cloudinaryVideoPreview(videoUrl.slice(idx + VIDEO_ASSET_MARKER.length), 'du_4,w_300');
};
